export default __webpack_public_path__ + "static/media/scfoundation-1.c212d868.jpg";